export default __webpack_public_path__ + "static/media/CG.cfdf4868.svg";